import { render, staticRenderFns } from "./CallRecordsCalculate.vue?vue&type=template&id=1770ef1c&scoped=true&"
import script from "./CallRecordsCalculate.vue?vue&type=script&lang=js&"
export * from "./CallRecordsCalculate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1770ef1c",
  null
  
)

component.options.__file = "CallRecordsCalculate.vue"
export default component.exports